import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

type UpdateUserFlagsParams = {
  userUuid: string
  flags: Record<string, boolean>
}

const updateUserFlags = async (
  apiClient: AxiosInstance,
  params: UpdateUserFlagsParams
): Promise<void> => {
  await apiClient.patch(`/api/users/${params.userUuid}/flags`, {
    flags: params.flags,
  })
}

export const useUpdateUserFlags = () => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation(
    (params: UpdateUserFlagsParams) => updateUserFlags(apiClient, params),
    {
      onSuccess: async (_, params: UpdateUserFlagsParams) => {
        await queryClient.invalidateQueries<Record<string, boolean>>(
          `user-flags-${params.userUuid}`,
          {
            refetchActive: true,
            refetchInactive: true,
          }
        )
      },
    }
  )
}
